module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_link_image_item-a8de314d97d1b9dd0ca65b7c7bca4b09.jpg";